import getStore from '../store/sharingStore';
import SharingPermissionItemState from '../store/schema/SharingPermissionItemState';
import { mutator } from 'satcheljs';
import { saveCalendarSharingPermissionForSelectedPerson } from '../actions/calendarSharing';

export default mutator(saveCalendarSharingPermissionForSelectedPerson, msg => {
    let viewState = getStore().viewState;
    if (viewState) {
        viewState.selectedRecipientPermission = msg.recipient;
    }
});

export { SharingPermissionItemState };
